import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="brutal-card p-6">
          <p className="label-mono">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) return <Navigate to="/" replace />;
  if (user.subscription_status === "expired" && !user.is_admin) {
    return <Navigate to="/pricing?expired=1" replace />;
  }
  return children;
}
